var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedRetry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5V12",
    stroke: "#EE3529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 14.25L12 12",
    stroke: "#EE3529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 9.34668H21.0195V5.59668",
    stroke: "#EE3529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8321 17.8313C16.6786 18.9857 15.2086 19.7721 13.6081 20.091C12.0075 20.4099 10.3484 20.2469 8.84051 19.6227C7.33263 18.9984 6.04376 17.941 5.13694 16.5842C4.23012 15.2273 3.74609 13.632 3.74609 12C3.74609 10.368 4.23012 8.7727 5.13694 7.41585C6.04376 6.059 7.33263 5.00158 8.84051 4.37735C10.3484 3.75313 12.0075 3.59014 13.6081 3.90902C15.2086 4.22789 16.6786 5.0143 17.8321 6.16875L21.0196 9.34688",
    stroke: "#EE3529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRetry);
export default __webpack_public_path__ + "static/media/redRetry.a54570bec668947b2dc3fe7c8443075e.svg";
export { ForwardRef as ReactComponent };